import classNames from 'classnames';

const Twitter = ({ className = '' }) => (
  <svg
    width="24px"
    height="24px"
    viewBox="0 0 24 24"
    xmlns="http://www.w3.org/2000/svg"
    xlinkHref="http://www.w3.org/1999/xlink"
    className={classNames('icon', className)}
  >
    <title>Twitter</title>
    <g id="Twitter" stroke="none" strokeWidth="1" fill="none" fillRule="evenodd">
      <path
        d="M8.7896,20.7511752 C16.3368,20.7511752 20.4648,14.4983752 20.4648,9.07597523 C20.4648,8.89837523 20.4648,8.72157523 20.4528,8.54557523 C21.2558651,7.96470391 21.9490844,7.24547874 22.5,6.42157523 C21.7511032,6.75341664 20.9566634,6.97103814 20.1432,7.06717523 C20.9997952,6.55436087 21.6408988,5.74779281 21.9472,4.79757523 C21.141726,5.27553948 20.2605169,5.61238484 19.3416,5.79357523 C18.0696662,4.44109065 16.0485755,4.11006529 14.4116394,4.98611917 C12.7747034,5.86217304 11.92902,7.72743581 12.3488,9.53597523 C9.04951659,9.37057485 5.97558062,7.81223384 3.892,5.24877523 C2.80289821,7.12369101 3.35919031,9.52226281 5.1624,10.7263752 C4.50939296,10.7070213 3.8706235,10.5308658 3.3,10.2127752 C3.3,10.2295752 3.3,10.2471752 3.3,10.2647752 C3.30053451,12.2180496 4.67740119,13.9004034 6.592,14.2871752 C5.98789568,14.4519273 5.35406447,14.4760107 4.7392,14.3575752 C5.27675834,16.0291135 6.81725965,17.1742023 8.5728,17.2071752 C7.11978803,18.3491208 5.32484761,18.9690374 3.4768,18.9671752 C3.15032286,18.9665485 2.82416325,18.9467812 2.5,18.9079752 C4.37650876,20.1121965 6.55993072,20.7509488 8.7896,20.7479752"
        id="twitter"
        fill="currentColor"
        fillRule="nonzero"
      />
    </g>
  </svg>
);

Twitter.propTypes = {
  className: PropTypes.string,
};

export default Twitter;
